import Service from './Service';

export default class Offer extends Service {

  listOnUs({dayOfferSort}) {
    return this.axiosInstance.get(`/offers/onUs${dayOfferSort? '?dayOfferSort=' + dayOfferSort: ''}`);
  }

  listOffUs({ partner }) {
    return this.axiosInstance.get(`/offers/offUs?partner=${partner}`);
  }

  listAll() {
    return this.axiosInstance.get(`/offers/all`);
  }

  listAllByUser() {
    return this.axiosInstance.get(`/offers/user`);
  }

  listActiveFromUser() {
    return this.axiosInstance.get(`/offers/user/active`);
  }

  listBySearch({ search, limit, categoryList, tag, partner, aleatory, onUsSearch }) {
    return this.axiosInstance.get(`/offers/search?limit=${limit}${search ? '&search=' + search : ''}${categoryList ? '&categoryList=' + categoryList : ''}${tag ? '&tag=' + tag : ''}${partner ? '&partner=' + partner : ''}${aleatory ? '&aleatory=' + aleatory : ''}${onUsSearch ? '&onUsSearch=' + onUsSearch : ''}`)
  }

  findByID({ offerID }) {
    return this.axiosInstance.get(`/offers/${offerID}`);
  }

  findByTop({ limit, onUsSearch }) {
    return this.axiosInstance.get(`offers/top${limit ? '?limit=' + limit : ''}${onUsSearch ? '&onUsSearch=' + onUsSearch : ''}`)
  }

  activeOffer({ offerId }) {
    return this.axiosInstance.post(`offers/redeem`, { offer: offerId });
  }
  
}
